import React from "react";
import { Result, Button } from "antd";

/**
 * Filet de sécurité React : transforme une exception au rendu en écran d'erreur
 * propre au lieu d'une page blanche (qui survient en l'absence d'Error Boundary).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log pour debug
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      const msg =
        (this.state.error && this.state.error.message) ||
        "Une erreur inattendue est survenue lors du chargement de cette page.";
      return (
        <div style={{ padding: 24 }}>
          <Result
            status="error"
            title="Une erreur est survenue"
            subTitle={msg}
            extra={[
              <Button
                key="reload"
                type="primary"
                onClick={() => window.location.reload()}
              >
                Recharger la page
              </Button>,
              <Button
                key="home"
                onClick={() => {
                  window.location.href = "/";
                }}
              >
                Retour à l'accueil
              </Button>,
            ]}
          />
        </div>
      );
    }
    return this.props.children;
  }
}
